<div class="sx-snackbar-container">
    <div class="sx-snackbar__body">
        @if(data?.title && data?.title !==''){
            <h4>{{data.title}}</h4>
        }
        @if(data?.message && data?.message !=='' && data.validationErrors?.length !== 1){
            <span class="sx-snackbar__message" data-cy="snackbar-message">{{data.message}}</span>
        }
        
        @if(data.validationErrors?.length === 1){
            <span class="sx-snackbar__message" data-cy="snackbar-message">{{data.validationErrors[0].message}}</span>
        }
        
        @if(data?.validationErrors && data?.validationErrors.length > 1){
            <ul>
                @for(item of data.validationErrors; track item){
                    <li>{{item.field}} - {{item.message}}</li>
                }
            </ul>
        }
    </div>
    @if(hasAction){
        <div>
            <span (click)="action()">
                <svg class="sx-snackbar__action">
                    <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
                </svg>
            </span>
        </div>
    }
    @if(data.snackbarType === 'error' && !data.showReAuth){
        <div class="sx-snackbar__buttons">
            <button mat-button class="sx-button sx-button--red" (click)="action()">
                <svg class="sx-snackbar__action">
                    <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
                </svg>
            </button>
        </div>
    }
</div>